import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckPermissions, DownloadFile } from './Shared';

const ReportPrepaidHireEndingData = () => {
    let navigate = useNavigate();
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [invoicedUpUntilStartDate, setInvoicedUpUntilStartDate] = React.useState("");
    const [invoicedUpUntilEndDate, setInvoicedUpUntilEndDate] = React.useState("");

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunPrepaidHireEndingReport");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied")
        }
    }

    const handleStartDateChange = (e: any) => {
        let error = errors;
        delete error["invoicedUpUntilStartDate"];
        setErrors(error);

        setInvoicedUpUntilStartDate(e.target.value);
    }

    const handleEndDateChange = (e: any) => {
        let error = errors;
        delete error["invoicedUpUntilEndDate"];
        setErrors(error);

        setInvoicedUpUntilEndDate(e.target.value);
    }

    const validate = () => {
        let errorsList: any = {};
        let formIsValid = true;

        if (!invoicedUpUntilStartDate) {
            formIsValid = false;
            errorsList["invoicedUpUntilStartDate"] = "Invoiced Up Until Start Date is required";
        }

        if (!invoicedUpUntilEndDate) {
            formIsValid = false;
            errorsList["invoicedUpUntilEndDate"] = "Invoiced Up Until End Date is required";
        }

        if (invoicedUpUntilStartDate && invoicedUpUntilEndDate && invoicedUpUntilEndDate < invoicedUpUntilStartDate) {
            formIsValid = false;
            errorsList["invoicedUpUntilStartDate"] = "Start Date must be < End Date";
        }

        setErrors(errorsList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (validate()) {
            runRpt();
        }
    }

    const runRpt = async () => {
        var url = "/report/ReportPrepaidJobsEnding/" + invoicedUpUntilStartDate + "/" + invoicedUpUntilEndDate + "/-1/-1/-1";
        window.open(url, '_blank');
    }

    const exportReport = (e: any) => {
        e.preventDefault();

        if (validate()) {
            exportRpt();
        }
    }

    const exportRpt = async () => {
        const apiURL = 'ExportPrepaidJobsEndingReportData?InvoicedUpUntilStartDate=' + invoicedUpUntilStartDate + "&InvoicedUpUntilEndDate=" + invoicedUpUntilEndDate;
        var filename = "PrepaidCustomerJobsEnding.xlsx";
        await DownloadFile(apiURL, filename);
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Prepaid Customer Jobs Ending</h1>
            </div>
            <div className="marginTop20">
                <span>Select a start and end date to search all prepaid customer jobs where the hire is ending between the start and end dates. </span>
            </div>
            <div>
                <label className="input-group" htmlFor="invoicedUpUntilStartDate">
                    <span className="label">Start Date</span>
                    <input type='date' id="invoicedUpUntilStartDate" name="invoicedUpUntilStartDate" className='input' value={invoicedUpUntilStartDate} onChange={(e) => handleStartDateChange(e)}></input>
                </label>
                <span className={errors["invoicedUpUntilStartDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["invoicedUpUntilStartDate"]}</span>
            </div>
            <div>
                <label className="input-group" htmlFor="invoicedUpUntilEndDate">
                    <span className="label">End Date</span>
                    <input type='date' id="invoicedUpUntilEndDate" name="invoicedUpUntilEndDate" className='input' value={invoicedUpUntilEndDate} onChange={(e) => handleEndDateChange(e)}></input>
                </label>
                <span className={errors["invoicedUpUntilEndDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["invoicedUpUntilEndDate"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel marginRight10" type='button' onClick={runReport}>Run Report</button>
            <button className="defaultbutton" type='button' onClick={exportReport}>Export to Excel</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)
};

export default ReportPrepaidHireEndingData;